import { Component, OnInit } from '@angular/core';

interface Order {
  orderId: string;
  date: string;
  customerName: string;
  totalAmount: string;
  status: 'Pending' | 'Completed' | 'Cancelled';
  paymentMethod: string;
}

@Component({
  selector: 'app-order',
  standalone: false,
  templateUrl: './order.component.html',
  styleUrl: './order.component.scss',
})
export class OrderComponent implements OnInit {
  orders: Order[] = [];

  ngOnInit(): void {
    this.loadOrders();
  }

  loadOrders(): void {
    // Mock data (Replace with API call in the future)
    this.orders = [
      {
        orderId: 'ORD12345',
        date: '2025-03-10',
        customerName: 'John Doe',
        totalAmount: '£25.00',
        status: 'Pending',
        paymentMethod: 'Card',
      },
      {
        orderId: 'ORD12346',
        date: '2025-03-09',
        customerName: 'Jane Smith',
        totalAmount: '£15.50',
        status: 'Completed',
        paymentMethod: 'Cash',
      },
      {
        orderId: 'ORD12347',
        date: '2025-03-08',
        customerName: 'Bob Johnson',
        totalAmount: '£40.00',
        status: 'Cancelled',
        paymentMethod: 'Stripe',
      },
    ];
  }
}
